import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";

const TYPES = ["Neighborhood", "Workplace", "Church", "Apartment/Community", "Friends/Family", "Business", "Organization", "Other"];

export default function BookGroup() {
  const [form, setForm] = useState({
    organizer_name: "", email: "", phone: "", location: "", group_type: "Neighborhood",
    estimated_vehicles: 3, preferred_date: "", notes: "",
  });
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async () => {
    setSubmitting(true);
    try {
      await api.post("/group-inquiries", { ...form, estimated_vehicles: Number(form.estimated_vehicles) });
      setDone(true);
      toast.success("Inquiry received! We'll be in touch shortly.");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Something went wrong");
    } finally { setSubmitting(false); }
  };

  if (done) {
    return (
      <div className="max-w-2xl mx-auto px-4 py-16 text-center">
        <div className="text-xs uppercase tracking-widest text-[#CCFF00]">Received</div>
        <h1 className="font-display text-4xl mt-2">Thanks for reaching out</h1>
        <p className="text-zinc-400 mt-3">A team member will contact you soon to coordinate a group service.</p>
      </div>
    );
  }

  return (
    <div className="max-w-2xl mx-auto px-4 py-10">
      <div className="text-xs uppercase tracking-widest text-[#CCFF00]">Group Booking</div>
      <h1 className="font-display text-4xl mt-2">Book & Save Together</h1>
      <p className="text-zinc-400 mt-3">Get better pricing when we service multiple vehicles at one location. Perfect for neighborhoods, workplaces, churches, apartment communities, and organizations.</p>

      <div className="mt-8 space-y-4">
        {[
          ["organizer_name", "Your name"], ["email", "Email"], ["phone", "Phone"], ["location", "Location / address"],
        ].map(([k, lbl]) => (
          <input key={k} data-testid={`group-${k}`} placeholder={lbl} value={form[k]}
            onChange={(e) => setForm({ ...form, [k]: e.target.value })}
            className="w-full px-4 py-3 rounded-xl border border-zinc-700 focus:border-[#CCFF00] outline-none" />
        ))}
        <div className="grid grid-cols-2 gap-3">
          <select data-testid="group-type" value={form.group_type}
            onChange={(e) => setForm({ ...form, group_type: e.target.value })}
            className="px-4 py-3 rounded-xl border border-zinc-700 focus:border-[#CCFF00] outline-none">
            {TYPES.map((t) => <option key={t} value={t}>{t}</option>)}
          </select>
          <input data-testid="group-estimated-vehicles" type="number" min="1"
            value={form.estimated_vehicles}
            onChange={(e) => setForm({ ...form, estimated_vehicles: e.target.value })}
            placeholder="Estimated vehicles"
            className="px-4 py-3 rounded-xl border border-zinc-700 focus:border-[#CCFF00] outline-none" />
        </div>
        <input data-testid="group-preferred-date" type="date" value={form.preferred_date}
          onChange={(e) => setForm({ ...form, preferred_date: e.target.value })}
          className="w-full px-4 py-3 rounded-xl border border-zinc-700 focus:border-[#CCFF00] outline-none" />
        <textarea data-testid="group-notes" placeholder="Notes"
          value={form.notes} onChange={(e) => setForm({ ...form, notes: e.target.value })}
          className="w-full px-4 py-3 rounded-xl border border-zinc-700 focus:border-[#CCFF00] outline-none min-h-[100px]" />
        <button data-testid="group-submit-btn" disabled={submitting || !form.organizer_name || !form.email || !form.phone || !form.location}
          onClick={submit} className="neon-btn w-full py-4 rounded-xl">
          {submitting ? "Sending..." : "Send inquiry"}
        </button>
      </div>
    </div>
  );
}
